/**
 * API 엔드포인트 상수
 */

export const API_URLS = {
  // 그룹 관리
  CREATE_GROUP: '/api/tutor/groups',
  LOAD_HISTORY: '/api/tutor/groups',
  EDIT_GROUP_LIST: process.env.REACT_APP_TUTOR_GROUP || '/tutor/group',
  GROUP_LIST: process.env.REACT_APP_TUTOR_GROUP_LIST || '/tutor/group/list',
  ADD_GROUP: process.env.REACT_APP_TUTOR_GET_HISTORY_LIST || '/api/v1/tutor/group/chat', // 레거시와 동일
  STORAGE_HISTORY: process.env.REACT_APP_TUTOR_GET_STOARGE_GROUP_LIST || '/tutor/storage',

  // 메시지
  SAVE_MESSAGE: '/api/tutor/messages',
  SEND_MESSAGE_STREAM: '/api/tutor/messages/stream',
  CHAT_HISTORY: process.env.REACT_APP_BACK_TUTOR_HISTORY || '/api/v1/tutor/his', // 레거시와 동일

  // 검색
  SEARCH: '/api/tutor/search',

  // 사용자
  GET_USER_PROFILE: '/api/users/profile',
  UPDATE_USER_PROFILE: '/api/users/profile',

  // 히스토리
  GET_HISTORY_LIST: '/api/tutor/history',
  DELETE_HISTORY: '/api/tutor/history/:id',
  ARCHIVE_HISTORY: '/api/tutor/history/:id/archive',

  // 피드백 & 평가
  REACTION: process.env.REACT_APP_TUTOR_EVALUATION || '/tutor/evaluation',

  // 샘플 질문 & 페르소나
  CATEGORY_LIST: process.env.REACT_APP_TUTOR_CATEGORY || '/tutor/category',
  PERSONA: process.env.REACT_APP_SETTINGS_PERSONA || '/settings/persona',

  // 공유
  CREATE_URL: process.env.REACT_APP_TUTOR_SHARE_LINK || '/api/v1/tutor/share',
  SHARE_LIST: process.env.REACT_APP_TUTOR_SHARE_LIST || '/api/v1/tutor/shares',

  // 파일 업로드
  FILE_UPLOAD: process.env.REACT_APP_TUTOR_UPLOAD || process.env.REACT_APP_SOCRATES_UPLOAD || '/tutor/upload',

  // 기타
  CLARIO: process.env.REACT_APP_CLARIO_SERVER || '',
  REFERER_URL: process.env.REACT_APP_REFERER_URL || '',
};

/**
 * 환경별 기본 URL
 */
export const getApiBaseUrl = (): string => {
  const env = process.env.REACT_APP_ENV || 'dev';

  const baseUrls: Record<string, string> = {
    dev: 'http://localhost:8000',
    staging: 'https://api-staging.example.com',
    production: 'https://api.example.com',
  };

  return baseUrls[env] || baseUrls.dev;
};
